import { ensureJson, RestClient } from 'slipstream-components';

const restClient = new RestClient();
const iamAPI = {
  async getActiveThemes(): Promise<any[]> {
    const url = '/multiple_theming/activeTheme';
    const resp = await restClient.get(url);
    const themes = ensureJson(resp.body).theme;
    return themes;
  },
};

export default iamAPI;
